export default __webpack_public_path__ + "static/media/Saibaba3.3e1fefc1.jpg";